var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_809_6504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.02148L14 14.0215",
    stroke: "#4A5056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05646 7.0791C6.80628 7.32911 6.66565 7.66827 6.66553 8.02196C6.6654 8.37566 6.80579 8.71491 7.0558 8.9651C7.30581 9.21529 7.64497 9.35591 7.99866 9.35604C8.35235 9.35616 8.69161 9.21578 8.9418 8.96577",
    stroke: "#4A5056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5715 11.5872C10.4842 12.3205 9.29483 12.6879 8.00016 12.6879C5.3335 12.6879 3.1115 11.1325 1.3335 8.0212C2.24616 6.42453 3.2755 5.23786 4.4215 4.46053M6.24216 3.59786C6.81377 3.43435 7.40563 3.35243 8.00016 3.35453C10.6668 3.35453 12.8888 4.90987 14.6668 8.0212C14.1482 8.92853 13.5922 9.70386 12.9982 10.3465L6.24216 3.59786Z",
    stroke: "#4A5056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_809_6504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0214844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eyeOff.122e0d1ee2216fd6fa064b676c73014e.svg";
export { ForwardRef as ReactComponent };